// extracted by mini-css-extract-plugin
module.exports = {"container":"NameplateImage_container__pWC1H","image":"NameplateImage_image__Hq_f5"};